import { InjectionToken } from "@angular/core";

import { UiMenuService } from "../services/menu.service";

export const UiIsMenuInsideDropDownToken = new InjectionToken<boolean>("UiIsInDropDownMenuToken");
export const UiMenuServiceLocalToken = new InjectionToken<UiMenuService>("UiMenuServiceLocalToken");
